import { Action, initialState, State } from "store/store";

export const setTheme = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    themeId: data.id,
    theme: { ...(state as any).theme, ...data.data },
  };

  return nextState;
};
